// extracted by mini-css-extract-plugin
export default {"logo":"\"./linqlawhublogo.svg\"","collapsedLogo":"\"./linqlawhubIcon.svg\""};